import { constantTree } from "../../../core/events/ConstantTree";

export const privacyPolicyTree = constantTree({
    Content: {
        Get: ""
    }
})